import { PersonalMenuTemplateSharingByTenantLinkContainer } from "../../../../../models/aggregates/personal-menu/personal-menu-template-sharing-by-tenant-link-container.model";
import { BaseApiTemplateService, Core2Config } from "../shared";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class PersonalMenuTemplateSharingByTenantLinkService extends BaseApiTemplateService<PersonalMenuTemplateSharingByTenantLinkContainer> {
  url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-psnl-menu-template-sharing-by-tenant-link/" + Core2Config.LOGIN_EP_SUFFIX;
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-psnl-menu-template-sharing-by-tenant-link/" + Core2Config.LOGIN_EP_SUFFIX;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "app-psnl-menu-template-sharing-by-tenant-link/" + Core2Config.LOGIN_EP_SUFFIX;
    this.httpClient = http;
  }
}